const CardData5 = [
  
  {
    title: 'War',
    description:
      "War (llamada inicialmente Eric Burdon & War) es una banda estadounidense de funk originaria de Long Beach, California. Fundada en 1969 y que se encuentra vigente hasta el día de hoy. Es la banda del exvocalista de The Animals. Uno de sus grandes hits, es el sencillo Low Rider, además de la famosa canción de 1975: Why Can't We Be Friends?..",
    videourl:
      'https://youtube.com/playlist?list=PLKzztqk1CWGnqkARbpvDmM-ptA6Z8uuN1',
    price: '$50',
    coverImg: 'war.jpeg',
    category: 'Funk & Groove',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://war.com/',
    youtube: 'https://www.youtube.com/c/war/videos',
    facebook: 'https://www.facebook.com/WARTHEBAND',
    instagram: 'https://www.instagram.com/wartheband/',
    twitter: 'https://twitter.com/WARtheBand',
    spotify: 'https://open.spotify.com/artist/3ICyfoySNDZqtBVmaBT84I',
    deezer: 'https://www.deezer.com/mx/artist/10129',
    apple: 'https://music.apple.com/mx/artist/war/261730408',
    soundcloud: 'https://soundcloud.com/war-official',
    tidal: 'https://listen.tidal.com/artist/3522622',
    wiki: 'https://es.wikipedia.org/wiki/War_(banda)',
    ticketmaster: 'https://www.ticketmaster.com/war-tickets/artist/736419',
    tiktok: 'https://www.tiktok.com/@warthebandofficial',
    napster: 'https://us.napster.com/artist/war',
  },

  {
    title: 'Sublime',
    description:
      "Sublime fue una banda estadounidense que combinaba el reggae, el hardcore punk y el ska punk, originaria de Long Beach (California), formada en 1988.1​ Los miembros de la banda, los cuales no cambiaron hasta su separación, eran Bradley Nowell (cantante y guitarra), Eric Wilson (bajo eléctrico) y Bud Gaugh en la batería.Lou Dog, el dálmata de Nowell, era la mascota de la banda. Michael 'Miguel' Happoldt y Marshall 'Field' Goodman contribuyeron con algunas canciones de la banda. El cantante Nowell murió de una sobredosis de heroína en 1996. Dos meses después el grupo tendría gran éxito comercial. En 1997, algunas canciones póstumas como -'Santeria', -'The Wrong Way', -'Doin Time' y 'April 29, 1992 (Miami)' fueron emitidas en la radio en los Estados Unidos",
    videourl: 'https://youtube.com/playlist?list=PL5971EBE5A63EA1C5',
    price: 36,
    coverImg: 'sublime.jpeg',
    category: 'Rock Alternativo',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://sublimelbc.com/#!/',
    youtube: 'https://www.youtube.com/channel/UCEJ-A6sXsxg0PxdUjgrF2Jw',
    facebook: 'https://www.facebook.com/Sublime',
    instagram: 'https://www.instagram.com/sublime/',
    twitter: 'https://twitter.com/sublime',
    spotify: 'https://open.spotify.com/artist/0EdvGhlC1FkGItLOWQzG4J',
    deezer: 'https://www.deezer.com/mx/artist/410',
    apple: 'https://music.apple.com/mx/artist/sublime/63480',
    soundcloud: 'https://soundcloud.com/sublimeofficial',
    tidal: 'https://listen.tidal.com/artist/3500750',
    wiki: 'https://es.wikipedia.org/wiki/Sublime_(banda)',
    ticketmaster:
      'https://www.ticketmaster.com/sublime-with-rome-tickets/artist/1417095',
    tiktok: 'https://www.tiktok.com/@sublimeofficial?lang=es',
    napster: 'https://web.napster.com/artist/art.61779',
  },
  {
    title: 'Beastie Boys',
    description:
      'Beastie Boys fue un grupo musical de rap neoyorquino fundado en Brooklyn en 1981. Comenzaron tocando hardcore punk en sus primeras grabaciones para la disquera independiente Ratcage Records de David Parsons. Habiendo asimilado la cultura callejera de la gran manzana desde 1983 comenzaron a experimentar con hip hop y hacer rap. También han editado discos basados en el funk y el jazz y es frecuente que en sus discos de hip hop incluyan rock o punk o algún corte acústico. También son conocidas las actividades de turntablism y de producción musical de sus miembros. Según Mike D., Beastie quiere decir: Boys Entering Anarchistic States Towards Internal Excellence',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_mv36h4Y-yvaQcMMpsH3vNWKRDMFuhUhkY',
    price: 36,
    coverImg: 'beastieboys.jpeg',
    category: 'Rap Alternativo',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://beastieboys.com/',
    youtube: 'https://www.youtube.com/channel/UCpRUSBcRWUQZIj3_jWF19Dg',
    facebook: 'https://www.facebook.com/beastieboys',
    instagram: 'https://www.instagram.com/beastieboysstory/',
    twitter: 'https://twitter.com/beastieboys',
    spotify: 'https://open.spotify.com/artist/03r4iKL2g2442PT9n2UKsx',
    deezer: 'https://www.deezer.com/mx/artist/194746',
    apple: 'https://music.apple.com/mx/artist/beastie-boys/1971863',
    soundcloud: 'https://soundcloud.com/beastieboys',
    tidal: 'https://listen.tidal.com/artist/8963',
    wiki: 'https://es.wikipedia.org/wiki/Beastie_Boys',
    ticketmaster:
      'https://www.ticketmaster.com/beastie-boys-tickets/artist/702455',
    tiktok: 'https://www.tiktok.com/@beastieboys_tiktok?lang=es',
    napster: 'https://web.napster.com/artist/art.4794',
  },
  {
    title: 'Dread Mar I',
    description:
      ' Dread Mar-I, nombre artístico de Mariano Javier Castro (Lanús, Provincia de Buenos Aires, Argentina; 31 de enero de 1978), es un cantante argentino de reggae rock, ampliamente considerado como uno de los artistas más populares, importantes e influyentes del reggae y del rock en toda Latinoamérica,​ y como uno de los más importantes del rock argentino surgidos en la década de los años 2010.',
    videourl:
      'http://youtube.com/playlist?list=OLAK5uy_lwPMwUUiTid7fR5kRgev2rlV-rBME7fnI',
    price: '$50',
    coverImg: 'dreadMar.jpg',
    category: 'Reggae',
    location: 'Argentina',
    locationImg: 'argentinaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://es.wikipedia.org/wiki/Dread_Mar-I',
    youtube: 'https://www.youtube.com/channel/UCXc3ye1CUoy2roNeZZB_rNA',
    facebook: 'https://www.facebook.com/dreadmari',
    instagram: 'https://www.instagram.com/dreadmari/',
    twitter: 'https://twitter.com/dreadmari',
    spotify: 'https://open.spotify.com/artist/1aw0Cdl1DIrtUrUA6fGbAR',
    deezer: 'https://www.deezer.com/mx/artist/4278295',
    apple: 'https://music.apple.com/mx/artist/dread-mar-i/544185872',
    soundcloud: 'https://soundcloud.com/dreadmari',
    tidal: 'https://listen.tidal.com/artist/4685160',
    wiki: 'https://es.wikipedia.org/wiki/Dread_Mar-I',
    ticketmaster:
      'https://www.ticketmaster.com/dread-mar-i-tickets/artist/2144576',
    tiktok: 'https://www.tiktok.com/@dreadmarii?lang=es',
    napster: 'https://mx.napster.com/artist/dread-mar-i',
  },
  {
    title: 'Los Pericos',
    description:
      ' Los Pericos es una banda de reggae y ska argentina fundada en 1986. En 2006 había superado los dos millones y medio de discos vendidos y más de tres mil presentaciones en vivo. Fueron nombrados embajadores del reggae por Jamaica..',
    videourl:
      'https://youtube.com/playlist?list=PL5l3Oa8FE8lgHrUKRDJMGU_z1zQxeA73x',
    price: '$50',
    coverImg: 'lospericos.jpg',
    category: 'Reggae',
    location: 'Argentina',
    locationImg: 'argentinaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://pericos.com/',
    youtube: 'https://www.youtube.com/channel/UCbVxcCD25pMVM4RVPb15DVA',
    facebook: 'https://www.facebook.com/Lospericos?fref=ts',
    instagram: 'https://www.instagram.com/los_pericos/',
    twitter: 'https://www.instagram.com/los_pericos/',
    spotify: 'https://open.spotify.com/artist/7FnZWGw9lwOr7WzieTKEPR',
    deezer: 'https://www.deezer.com/mx/artist/6441',
    apple: 'https://music.apple.com/mx/artist/los-pericos/559050',
    soundcloud: 'https://soundcloud.com/los-pericos',
    tidal: 'https://listen.tidal.com/artist/56840',
    wiki: 'https://es.wikipedia.org/wiki/Los_Pericos',
    ticketmaster:
      'https://www.ticketmaster.com/los-pericos-tickets/artist/782857',
    tiktok: 'https://www.tiktok.com/@lospericosoficial?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000RHTAWA/los-pericos',
  },
  {
    title: 'Los Cafres',
    description:
      ' Los Cafres es una banda argentina de reggae. Formada en 1987 en Buenos Aires, fue la primera en cantar roots reggae en castellano. Liderados por su cantante Guillermo Bonetto,1​ a lo largo de sus más de 30 años de historia Los Cafres editaron catorce discos, de los cuales tres se convirtieron en Disco de Oro. En reiteradas ocasiones, fueron nominados a los Premios Grammy..',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nktYf49We-hyWSs_4QO6sHQ2ViNj2DEKg',
    price: '$50',
    coverImg: 'loscafres.jpg',
    category: 'Reggae',
    location: 'Argentina',
    locationImg: 'argentinaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://loscafres.net/',
    youtube: 'https://www.youtube.com/channel/UCeQ-A7LTWGmN4AIVpVo7u1w',
    facebook: 'https://www.facebook.com/loscafrespaginaoficial',
    instagram: 'https://www.instagram.com/loscafres/',
    twitter: 'https://twitter.com/LOSCAFRES',
    spotify: 'https://open.spotify.com/artist/2ST5XwWB4uXGKk2NXP8DUI',
    deezer: 'https://www.deezer.com/mx/artist/14523',
    apple: 'https://music.apple.com/mx/artist/los-cafres/128904969',
    soundcloud: 'https://soundcloud.com/loscafres',
    tidal: 'https://listen.tidal.com/artist/3685831',
    wiki: 'https://es.wikipedia.org/wiki/Los_Cafres',
    ticketmaster:
      'https://www.ticketmaster.com/los-cafres-tickets/artist/2104221',
    tiktok: 'https://www.tiktok.com/@loscafres?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000XXRZ5M/los-cafres',
  },
  {
    title: 'Steel Pulse',
    description:
      'Steel Pulse (en castellano: Pulso de Acero) es una banda británica de reggae formada en 1975. Lanzaron doce discos de estudio y ganaron múltiples premios, además de haber vendido millones de álbumes.Fueron el primer grupo no jamaicano en ganar un premio Grammy a la categoría Mejor Disco de Reggae. Además, recibieron otras cinco nominaciones. Cuentan con doce álbumes de estudio, y son una de las bandas más importantes dentro del género',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_k4cMCSF-4r2RbA023_3RtRcERHd2GFsf8&si=Tbo9xwRtukiQcQNF',
    price: '$50',
    coverImg: 'steelpulse.gif',
    category: 'Reggae',
    location: 'UK',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://steelpulse.com/',
    youtube: 'https://www.youtube.com/channel/UC03Lkvcs07JBeLLz_6Q0N8g',
    facebook: 'https://www.facebook.com/SteelPulse',
    instagram: 'https://www.instagram.com/steelpulseofficial',
    twitter: 'https://x.com/steelpulse',
    spotify: 'https://open.spotify.com/artist/6UL7BodGc5iVmQGlMwHR0g',
    deezer: 'https://www.deezer.com/mx/artist/6542',
    apple: 'https://music.apple.com/mx/artist/steel-pulse/77420',
    soundcloud: 'https://soundcloud.com/steelpulseofficial',
    tidal: 'https://listen.tidal.com/artist/18906',
    wiki: 'https://es.wikipedia.org/wiki/Steel_Pulse',
    ticketmaster:
      'https://www.ticketmaster.com/steel-pulse-tickets/artist/733929',
    tiktok: 'https://www.tiktok.com/@paradisea.fest?lang=es',
    napster: 'https://music.amazon.com/artists/B000QJP8RA/steel-pulse',
  },
  {
    title: 'B-Side Players',
    description:
      " B-Side Players is an American band formed in 1994. The band incorporates the sounds of Cuba, Jamaica, Mexico and Brazil with the funk, rock, jazz and hip-hop rhythms of their homeland. The band also drops a bit of Cumbia, gritty street Samba, Son Montuno and Jarocho into the mix. Described as War meets Lenny Kravitz by way of Ben Harper, the players have expanded their sound by playing with the likes of Harper, Ozomatli, The Wailers, James Brown, War and some of Cuba's best bands. They are signed to Jazz label Concord Music Group.",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_loScBE7-fr0Dt7oC7f62ZYg-xlTCqYcn0',
    price: '$50',
    coverImg: 'bsideplayers.jpg',
    category: 'Reggae',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://thebsideplayers.com/',
    youtube: 'https://www.youtube.com/channel/UCu0xee-dNPnQADqxRpoRIsg',
    facebook: 'https://www.facebook.com/bside.players',
    instagram: 'https://www.instagram.com/bsideplayers/',
    twitter: 'https://twitter.com/Bsideplayers',
    spotify: 'https://open.spotify.com/artist/5Plx1HJNBJ7R5neNjipqYT',
    deezer: 'https://www.deezer.com/mx/artist/56776512',
    apple: 'https://music.apple.com/mx/artist/b-side-players/14413871',
    soundcloud: 'https://soundcloud.com/b-side-players-official',
    tidal: 'https://listen.tidal.com/artist/12971',
    wiki: 'https://en.wikipedia.org/wiki/B-Side_Players',
    ticketmaster:
      'https://www.ticketmaster.com/b-side-players-tickets/artist/832727',
    tiktok: 'https://www.tiktok.com/@bsideplayersinc?lang=es',
    napster: 'https://www.napster.com/mx',
  },{
    title: 'Barrington Levy',
    description:
      'Barrington Ainsworth Levy (30 de abril de 1964, Clarendon, Jamaica) es un cantante, músico, compositor de canciones y productor discográfico de música reggae y dancehall.Conocido como "Mellow Canary" por su estilo marcado y su voz pura, es conocido como cantante original de la primera época del dancehall, inspirando a muchos otros artistas en su trayectoria.Barrington nació en West Kingston, pero pasó mucho tiempo de su juventud en Clarendon, donde desarrolló su riff experimentando con diferentes estilos vocales.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_k80kCBRlt07O_P-w-HKbE3_cptrNNlHkE&si=3lD4UNv4t9BLRzsS',
    price: '$50',
    coverImg: 'barrington.jpg',
    category: 'Reggae',
    location: 'Jamaica',
    locationImg: 'jamaicaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'http://www.barringtonlevy.com/',
    youtube: 'https://www.youtube.com/channel/UCOljnLR-TUM1l_zQ4PZhL9g',
    facebook: 'https://www.facebook.com/BarringtonLevy411',
    instagram: 'https://www.instagram.com/barringtonlevy411',
    twitter: 'https://x.com/MrLevy411',
    spotify: 'https://open.spotify.com/artist/5mMuiFhh7faS7qxnTLRA6u',
    deezer: 'https://www.deezer.com/mx/artist/2327',
    apple: 'https://music.apple.com/mx/artist/barrington-levy/308133',
    soundcloud: 'https://soundcloud.com/barrington-levy-official',
    tidal: 'https://listen.tidal.com/artist/16897',
    wiki: 'https://es.wikipedia.org/wiki/Barrington_Levy',
    ticketmaster:
      'https://www.ticketmaster.com/barrington-levy-tickets/artist/733903',
    tiktok: 'https://www.tiktok.com/@barringtonlevy411',
    napster: 'https://music.amazon.com/artists/B000QJI6LK/barrington-levy',
  },{
    title: 'Pato Banton',
    description:
      "Patrick Murray (más conocido como Pato Banton) es un cantante de reggae nacido en Birmingham, Inglaterra. Su primera aparición fue en 1982, con Pato and Roger a Go Talk (del disco Special Beat Service) junto con Ranking Roger del grupo de música ska English Beat. Fue, además, uno de los artistas invitados que aparecieron en el disco Baggariddim de UB40 en 1985..",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_lY5qbn1LEYaDbfG63Vd88ZcN-R4YalCp0&si=Afd1pM0YRThV-iOb',
    price: '$50',
    coverImg: 'patobanton.jpg',
    category: 'Reggae',
    location: 'Englang',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://officialpatobanton.com/',
    youtube: 'https://www.youtube.com/channel/UCFSeSrc7tsOzULDwZBbdLOw',
    facebook: 'https://www.facebook.com/patobantonandthenowgeneration',
    instagram: 'https://www.instagram.com/pato_banton_/?hl=en',
    twitter: 'https://x.com/The_Pato_Banton',
    spotify: 'https://open.spotify.com/artist/0cpt0xebTXatYk3KvnrU9m',
    deezer: 'https://www.deezer.com/en/artist/5835',
    apple: 'https://music.apple.com/us/artist/pato-banton/6769444',
    soundcloud: 'https://soundcloud.com/pato-banton',
    tidal: 'https://listen.tidal.com/artist/3513595',
    wiki: 'https://es.wikipedia.org/wiki/Pato_Banton',
    ticketmaster:
      'https://www.ticketmaster.com/pato-banton-tickets/artist/740340',
    tiktok: 'https://www.tiktok.com/@officialpatobanton?lang=es',
    napster: 'https://music.amazon.com/artists/B000QKH1Q0/pato-banton',
  },
  {
    title: 'Eek-A-Mouse',
    description:
      "Nacido en Kingston, Jamaica, Eek-A-Mouse comenzó su carrera musical cuando estaba en la universidad, lanzando dos singles de reggae que fueron producidos por su tutor de matemáticas, el Sr. Dehaney. Estas primeras obras estaban influenciadas por la música de Pablo Moses. Adoptó el nombre artístico Eek-A-Mouse en 1979, tomó el nombre de un caballo de carreras en el que solía apostar. Comenzó a grabar para Joe Gibbsen 1979, teniendo un éxito inmediato con Once a Virgin, que ahora tenía la influencia de Ranking Joe, y esto pronto fue seguido con Wa-Do-Dem y Modeling Queen.A finales de 1980, se vinculó con el productor Henry Junjo Lawes, con quien tuvo grandes éxitos en 1981 como Virgin Girl y un recut Wa-Do-Dem. En 1981, fue la estrella del Festival Reggae Sunsplash , animando al público que aún lloraba la muerte del ícono del reggae Bob Marley. Su asociación con Lawes condujo a una serie de singles y álbumes exitosos, y en 1982 sus éxitos incluyeron Wild Like a Tiger, For Hire and Removal, Do You Remember y Ganja Smuggling. El mismo año lanzó su segundo álbum, Wa Do Dem . El sencillo Operation Eradication mostró el lado serio de Hylton, la canción inspirada en el asesinato vigilante del amigo cercano y compañero DJ Errol Shorter.En 1983 sacó Mouse and the Man, producido por Linval Thompson, y Mouseketeer de 1984 , nuevamente producido por Lawes. También apareció en varios de los álbumes de dancehall en vivo de la época. En la segunda mitad de la década, su popularidad comenzó a disminuir ligeramente, y se dirigió a Estados Unidos con el álbum Assassinator en 1985. También viajó al Reino Unido para grabar The King and I el mismo año, el álbum dirigido también a la audiencia rock a la que había comenzado a apelar.Su álbum de 1988 Eek-A-Nomics le comenzó a dar una proyección internacional, generando un éxito en discotecas con The Freak. En 1991 volvió a la fama con U-Neek, que continuó con el estilo orientado al rock, incluyendo una versión de D'yer Mak'er de Led Zeppelin , y del cual se tomó el sencillo You're The One I Need. Pasó por un período de relativa tranquilidad antes de regresar en 1996 con el álbum Black Cowboy.También tiene una actuación en la película de gánsteres de 1991 New Jack City interpretando a un rastafari narcotraficante llamado Fat Smitty.Eek-A-Mouse es un habitual en Sunsplash y a menudo se une con el dúo de reggae Michigan & Smiley. Actuó en Jamaica por primera vez después de ocho años en agosto de 2015 en el Festival Marcus Garvey en Ocho Ríos.",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_lSIhRErJd29gmfktoYyiff9gkOEs49tQM&si=B-HF3rVWRFdh0tFM',
    price: '$50',
    coverImg: 'eekamouse.jpeg',
    category: 'Reggae',
    location: 'Jamaica',
    locationImg: 'jamaicaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.reggaeville.com/artist-details/eek-a-mouse/about/',
    youtube: 'https://www.youtube.com/channel/UCEkGgwcRLuF7Y0cLu7BfzgA',
    facebook: 'https://www.facebook.com/EekAMouseofficial',
    instagram: 'https://www.instagram.com/iameekamouse/?hl=en',
    twitter: 'https://x.com/eekamousetwitt',
    spotify: 'https://open.spotify.com/artist/6xqlgBccdlxUh5DeJSx2ho',
    deezer: 'https://www.deezer.com/mx/artist/2719',
    apple: 'https://music.apple.com/mx/artist/eek-a-mouse/348592',
    soundcloud: 'https://soundcloud.com/eek-a-mouse-official',
    tidal: 'https://listen.tidal.com/artist/3583355',
    wiki: 'https://es.wikipedia.org/wiki/Eek-A-Mouse',
    ticketmaster:
      'https://www.ticketmaster.com/eekamouse-tickets/artist/733887',
    tiktok: 'https://www.tiktok.com/@eekamousejam?lang=es',
    napster: 'https://music.amazon.com/artists/B000QJHMHY/eek-a-mouse',
  },
  {
    title: 'Burning Spear',
    description:
      "Winston Rodney (nacido el 1 de marzo de 1945), más conocido como Burning Spear, es un músico y cantante jamaiquino de roots reggae. Como muchos otros cantantes jamaicanos de reggae, Burning Spear es conocido por sus mensajes Rastafari.Rodney nació en Saint Ann's Bay, Condado de Middlesex (Jamaica), Jamaica, como Bob Marley y Marcus Garvey; ambos tuvieron una gran influencia en la vida de Rodney. Garvey por su filosofía, la cual Burning Spear abrazó con agrado, y Marley porque le ayudó directamente a empezar en el mundo de la música. Burning Spear fue originalmente el nombre del grupo de Rodney, llamado después Jomo Kenyatta, como el primer primer ministro y Presidente de la independizada Kenia. La fama que fue tomando el nombre del grupo hizo que gradualmente Burning Spear se convirtiera en sinónimo del nombre de Rodney.Burning Spear ha sido uno de los más fuertes defensores de la autodeterminación propugnada por Marcus Garvey y de la repatriación de todos los descendientes Africanos. Varios de sus trabajos conmemoran este activismo africano.En 2002, Burning Spear y su esposa, Sonia Rodney quien ha producido muchos de sus álbumes, fundaron Burning Spear Records.Burning Spear lleva un mensaje de honestidad, paz y amor, que integra con mensajes religiosos y políticos de Rasta y en favor la unidad negra..",
    videourl:
      'https://youtube.com/playlist?list=UULP-IgH9OyLNNio7nWEx9L2Kw&si=NmmYb5LIaD1s3D0a',
    price: '$50',
    coverImg: 'burningspear.jpg',
    category: 'Reggae',
    location: 'Jamaica',
    locationImg: 'jamaicaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.burningspearwebsite.com/',
    youtube: 'https://www.youtube.com/channel/UC-IgH9OyLNNio7nWEx9L2Kw',
    facebook: 'https://www.facebook.com/burningspearmusic',
    instagram: 'https://www.instagram.com/burningspear_zw24/?hl=en',
    twitter: 'https://x.com/burningmusic',
    spotify: 'https://open.spotify.com/artist/6qaKS0nzGP4hfjl4aFZmEU',
    deezer: 'https://www.deezer.com/mx/artist/2325',
    apple: 'https://music.apple.com/mx/artist/burning-spear/1587884',
    soundcloud: 'https://soundcloud.com/burning-spear-official',
    tidal: 'https://listen.tidal.com/artist/11093',
    wiki: 'https://es.wikipedia.org/wiki/Burning_Spear',
    ticketmaster:
      'https://www.ticketmaster.com/burning-spear-tickets/artist/733877',
    tiktok: 'https://www.tiktok.com/@burningspear13?lang=es',
    napster: 'https://music.amazon.com/artists/B000QJKI2U/burning-spear',
  },
  {
    title: 'Peter Tosh',
    description:
      "Winston Hubert McIntosh (29 de octubre de 1944, Westmoreland - 11 de septiembre de 1987, Kingston), más conocido como Peter Tosh, fue un músico de reggae jamaicano, defensor de los derechos humanos y activista pro-legalización del cannabis. Formó parte del grupo The Wailers en sus principios, para posteriormente tener una exitosa carrera como solista, además de ser uno de los más famosos representantes del movimiento Rastafari.Impulsó y difundió, al igual que Bob Marley, el reggae por todo el mundo y es considerado uno de los mejores artistas de reggae de todos los tiempos.Su firmeza en la lucha contra el sistema, su rechazo a la utilización bélica de las armas nucleares, la defensa de los derechos humanos y el rechazo público al apartheid (fue el primer gran compositor que se mostró en contra abiertamente), además de la legalización de la marihuana son unos de los temas fundamentales de la vida y la carrera musical de Peter Tosh.Crítico con la política de su país y global, llegó a decir: La verdad ha sido calificada como ilegal. Es peligroso tener la verdad en tu poder. Puedes ser culpable de un delito y condenado a muerte.Equal Rights, su éxito de 1977, incluye la conocida frase, repetida años después en muchas protestas Yo no quiero paz, quiero igualdad y justicia.Una de sus decisiones más conocidas fue cuando hizo perder a sus productores 78.000 dólares por no tocar en Israel, ya que los israelitas le vendían armas al Apartheid de África en ese tiempo.",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_kt0wfPzkqTm8j87SGafavi_i7efVR5HPM&si=5RnmtWt5YMs1vWXc',
    price: '$50',
    coverImg: 'petertosh.png',
    category: 'Reggae',
    location: 'Jamaica',
    locationImg: 'jamaicaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://petertosh.com/',
    youtube: 'https://www.youtube.com/channel/UCq1KxBXQebdZdQvr7YlqzYg',
    facebook: 'https://www.facebook.com/PeterTosh',
    instagram: 'https://www.instagram.com/petertosh/?hl=en',
    twitter: 'https://x.com/PeterTosh',
    spotify: 'https://open.spotify.com/artist/0oea1hwGMfUxZbLxJc1XUN',
    deezer: 'https://www.deezer.com/mx/artist/2326',
    apple: 'https://music.apple.com/mx/artist/peter-tosh/461717',
    soundcloud: 'https://soundcloud.com/peter-tosh-music',
    tidal: 'https://listen.tidal.com/artist/158',
    wiki: 'https://es.wikipedia.org/wiki/Peter_Tosh',
    ticketmaster:
      'https://www.ticketmaster.com/peter-tosh-tickets/artist/2717',
    tiktok: 'https://www.tiktok.com/@petertoshmusic?lang=es',
    napster: 'https://music.amazon.com.mx/search/peter+tosh?filter=IsLibrary%7Cfalse&sc=none',
  },
  {
    title: 'Manu Dibango',
    description:
      "Manu Dibango (1933–2020) was a legendary Cameroonian saxophonist, composer, and bandleader, best known for blending jazz, funk, and traditional African music. His global breakthrough came with the 1972 hit “Soul Makossa”, a funky, sax-driven track that became a major influence in pop, disco, and hip-hop. The refrain “ma-mako, ma-ma-sa, mako-mako-sa” from that song was famously sampled or echoed by artists like Michael Jackson (“Wanna Be Startin’ Somethin’”) and Rihanna (“Don’t Stop the Music”).",
    videourl:
      'https://youtube.com/playlist?list=PL18yhXvkVdCBqIaboqGRKYna69Ij4oKmc&si=zM5LyJ_wogonBwuM',
    price: '$50',
    coverImg: 'manudibango.jpg',
    category: 'Reggae',
    location: 'Africa',
    locationImg: 'africaflag.png',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.casafrica.es/es/persona/manu-dibango',
    youtube: 'https://www.youtube.com/channel/UCfIZtlCwzlbZxyREadjw-Qg',
    facebook: 'https://www.facebook.com/clubManuDibangOff',
    instagram: 'https://www.instagram.com/manu.dibango/?hl=en',
    twitter: 'https://x.com/ManuDibango_Off',
    spotify: 'https://open.spotify.com/artist/30UIjoCGuL3Fa5BOc3ayNW',
    deezer: 'https://www.deezer.com/mx/artist/4929',
    apple: 'https://music.apple.com/es/artist/manu-dibango/5361622',
    wiki: 'https://es.wikipedia.org/wiki/Manu_Dibango',
    ticketmaster:
      'https://www.ticketmaster.com/manu-dibango-tickets/artist/2124298',
    tiktok: 'https://www.tiktok.com/search/video?lang=es&q=Manu%20Dibango&t=1746110184265',
    napster: 'https://music.amazon.com.mx/artists/B000QJRK58',
  },
  {
        title: 'Imagine',
        description:
          'Imagine – Music Reinvented with Creative AIOn this channel, you’ll find bold musical recreations powered by artificial intelligence:🎭 Parodies and creative transformations of real bands reimagined in unexpected styles like reggae, jazz, or grunge.🎸 Fictional bands and original albums, crafted from scratch with AI tools, paying tribute to vintage, psychedelic, classic, or alternative sounds.All videos are fictional, artistic, and transformative works created for entertainment purposes only.They do not depict real performances and are not affiliated with any real artists, brands, or entities..',
        videourl:
          'https://youtu.be/KLTU65eEXEU?si=qihOz1By1IoyqAs-',
        price: 80,
        coverImg: 'imagine.jpg',
        category: 'AI',
        location: 'USA',
        locationImg: 'usaflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.paypal.com/donate/?hosted_button_id=28DP3MV9LX9YG',
        youtube: 'https://www.youtube.com/@Imagine-k6o',
            
      },
  {
    title: 'Gregory Issacs',
    description:
      "En su juventud, Isaacs se convirtió en el veterano en las competencias de talentos que regularmente tenían lugar en Jamaica. En 1968, hizo su debut discográfico a dúo con Winston Sinclair, Another Heartache, grabado por el productor Byron Lee.​ El sencillo fue poco vendido y más tarde Isaacs pasó a formar una agrupación con otros dos artistas (Penroe and Bramwell), durante el corto tiempo el trío The Concords, grabaron para Rupie Edwards y Prince Buster.​ el trío se separó en 1970 y Isaacs inició su carrera como solista, inicialmente él mismo producía y grababa sus canciones, también hacia muchas grabaciones para Edwards.En 1973 se asoció con otro joven cantante, Errol Dunkley para empezar la Compañía discográfica y tienda African Museum, y pronto tuvo su gran éxito con el tema «My Only Lover», tema por el cual fue acreditado como la primera grabación en el género Lovers rock.​ Grabó para otros productores musicales para también financiar la compañía discográfica African Museum, teniendo una serie de éxitos que van desde las baladas al Roots reggae, incluyendo el tema «All I Have Is Love», «Lonely Soldier», «Black a Kill Black», «Extra Classic», y su versión musical de Dobby Dobson «Loving Pauper».En 1974 empezó a trabajar con el productor Alvin Ranglin, y en ese año tuvo su primer sencillo número uno de Jamaica con Love Is Overdue.​ Isaacs grabó para muchos productores importantes de Jamaica durante los años 1970, incluyendo a Winston Niney Holness, Gussie Clarke («My Time»), Lloyd Campbell («Slavemaster»), Glen Brown, Harry Mudie, Roy Cousins, Sidney Crooks, y Lee Perry (Mr. Cop).​ Para más tarde en los años 1970, Isaacs fue uno de los más grandes intérpretes de reggae en el mundo, regularmente estaba de gira en los Estados Unidos y en el Reino Unido, cuestionados por Dennis Brown y Bob Marley.​ Entre 1977 y 1978, Isaacs una vez más se asocia con Alvin Ranglin, grabando una series de éxitos como: «Border» y Number One para la productora Ranglin's GG. El Estrellato internacional parecía estar asegurado para Isaacs en 1978, luego que firmó con la compañía discográfica británica Virgin Records rama de la empresa Front Line Records, y apareció en la película Rockers, en la que interpretó a Slavemaster.​ Los álbumes Cool Ruler y Soon Forward, no se vendieron tan bien como se esperaba, a pesar de que ahora se consideran uno de sus mejores trabajos.",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_lDOK8uy6AEcK_qX1zBAoG2i_gFdn7WxTo&si=tvKRTmBdGihX0Hwf',
    price: '$50',
    coverImg: 'gregoryisaacs.jpg',
    category: 'Reggae',
    location: 'Jamaica',
    locationImg: 'jamaicaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://worldmusiccentral.org/2023/09/17/essential-gregory-isaacs-treasure/',
    youtube: 'https://www.youtube.com/channel/UCrWrf0Dyue7UNulBwPhbI2A',
    facebook: 'https://www.facebook.com/gregory.issacs.58',
    instagram: 'https://www.instagram.com/gregoryisaacsoficial/?hl=en',
    twitter: 'https://x.com/GregAaron01',
    spotify: 'https://open.spotify.com/artist/6QHu71f8LLeT8n0GzfbYFc',
    deezer: 'https://www.deezer.com/en/artist/7065',
    apple: 'https://music.apple.com/us/artist/gregory-isaacs/77547',
    soundcloud: 'https://soundcloud.com/gregory-isaacs-official',
    tidal: 'https://listen.tidal.com/artist/16905',
    wiki: 'https://es.wikipedia.org/wiki/Gregory_Isaacs',
    ticketmaster:
      'https://www.ticketmaster.com/gregory-isaacs-tickets/artist/769554',
    tiktok: 'https://www.tiktok.com/search/video?lang=es&q=Gregory%20Isaacs&t=1726008005919',
    napster: 'https://music.amazon.com/artists/B000QJTVQ4/gregory-isaacs',
  },
  {
    title: 'Bob Marley',
    description:
      'Robert Nesta Marley (Nine Mile, parroquia de Saint Ann, 6 de febrero de 1945-Miami, Florida, 11 de mayo de 1981), más conocido como Bob Marley, fue un cantante y compositor jamaicano. Durante su carrera musical fue el líder, compositor y guitarrista de las bandas The Wailers (1964-1974) y Bob Marley & The Wailers (1974-1980). Marley sigue siendo el más conocido y respetado intérprete de la música reggae y es acreditado por ayudar a difundir tanto la música de Jamaica como el movimiento rastafari (del que era un miembro comprometido) a una audiencia mundial.',
    videourl:
      'https://youtube.com/playlist?list=PLnvVNd96RFMSBPq6GQj8XKsBmk3pGa60Y&si=rm0eRMUMEa2jCm0t',
    price: 36,
    coverImg: 'bobmarley.gif',
    category: 'Reggae',
    location: 'Jamaica',
    locationImg: 'jamaicaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.bobmarley.com/',
    youtube: 'https://www.youtube.com/channel/UCAlTDckOOQ2jREOvuCShGbw',
    facebook: 'https://www.facebook.com/BobMarley/',
    instagram: 'https://www.instagram.com/bobmarley/',
    twitter: 'https://twitter.com/bobmarley',
    spotify: 'https://open.spotify.com/artist/2QsynagSdAqZj3U9HgDzjD',
    deezer: 'https://www.deezer.com/mx/artist/719',
    apple: 'https://music.apple.com/mx/artist/bob-marley/121982',
    soundcloud: 'https://soundcloud.com/bob-marley-the-wailers',
    tidal: 'https://listen.tidal.com/artist/4067781',
    wiki: 'https://es.wikipedia.org/wiki/Bob_Marley',
    ticketmaster:
      'https://www.ticketmaster.com/bob-marley-festival-tickets/artist/1524551',
    tiktok: 'https://www.tiktok.com/@bobmarley?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000QJJU1K/bob-marley',
  },
  {
    title: 'Jamiroquai',
    description:
      'Jamiroquai es un grupo británico de funk y acid jazz que incluye matices de música disco y sonoridades de electrónica. Fue formado en 1992 por su líder, el cantante Jason Jay Kay, junto a Toby Smith, Stuart Zender, Nick Van Gelder y Wallis Buchanan. Con el tiempo, la banda ha sufrido numerosos cambios, tanto es así que con la excepción de Jason Kay ninguno de los integrantes originales permanece en el grupo en la actualidad.',
    videourl:
      'http://youtube.com/playlist?list=OLAK5uy_llWNt6ppxy59MLD0kitlNLJZ3PYx50ioo',
    price: 36,
    coverImg: 'jamiroquai.jpg',
    category: 'Funk',
    location: 'UK',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'http://jamiroquai.com/',
    youtube: 'https://www.youtube.com/user/jamiroquaivideo',
    facebook: 'https://www.facebook.com/Jamiroquai/',
    instagram: 'https://www.instagram.com/jamiroquaihq/',
    twitter: 'https://twitter.com/jamiroquaihq',
    spotify:
      'https://open.spotify.com/artist/6J7biCazzYhU3gM9j1wfid?play=true&utm_source=open.spotify.com&utm_medium=open',
    deezer: 'https://www.deezer.com/mx/artist/7',
    apple: 'https://music.apple.com/mx/artist/jamiroquai/475902',
    soundcloud: 'https://soundcloud.com/jamiroquai',
    tidal: 'https://listen.tidal.com/artist/526',
    wiki: 'https://es.wikipedia.org/wiki/Jamiroquai',
    ticketmaster:
      'https://www.ticketmaster.com/jamiroquai-tickets/artist/774399',
    tiktok: 'https://www.tiktok.com/@jamiroquaihq?lang=es',
    napster:
      'https://music.amazon.com.mx/artists/B000RHRALI/jamiroquai'
  },
  {
    title: 'Damian Marley',
    description:
      'Damian Robert Nesta «Jr. Gong» Marley (Kingston, Jamaica; 21 de julio de 1978) es un músico jamaicano, ganador de tres premios Grammy, y artista de roots reggae y dancehall. Es uno de los hijos menores de Bob Marley y el único hijo que tuvo con Cindy Breakspeare, Miss Mundo de 1976. Su apodo es Junior Gong, derivación del de su padre, Tuff Gong.',
    videourl:
      'https://youtube.com/playlist?list=PLKuBGsZcw87KBf6FDVHFCpoo4ENQHPAYL',
    price: 36,
    coverImg: 'damianmarley2.jpg',
    category: 'Reggae',
    location: 'Jamaica',
    locationImg: 'jamaicaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://damianmarley.com/',
    youtube: 'https://www.youtube.com/channel/UCV0TnBGv6txr79Oiwtmsm-g',
    facebook: 'https://www.facebook.com/damianmarley',
    instagram: 'https://www.instagram.com/damianmarley/',
    twitter: 'https://twitter.com/damianmarley',
    spotify: 'https://open.spotify.com/artist/3QJzdZJYIAcoET1GcfpNGi',
    deezer: 'https://www.deezer.com/mx/artist/254',
    apple: 'https://music.apple.com/mx/artist/bob-marley/121982',
    soundcloud: 'https://soundcloud.com/bob-marley-the-wailers',
    tidal: 'https://listen.tidal.com/artist/29899',
    wiki: 'https://es.wikipedia.org/wiki/Damian_Marley',
    ticketmaster:
      'https://www.ticketmaster.com/damian-jr-gong-marley-tickets/artist/826391',
    tiktok: 'https://www.tiktok.com/@damian_marley_?lang=es',
    napster:
      'https://music.amazon.com.mx/artists/B001GNL9V4/damian-marley',
  },
]

export default CardData5
